import { normalizeRoles } from '../constants/roles.js';

function getNormalizedRoles(user) {
  const rawRoles = Array.isArray(user?.roles)
    ? user.roles
    : (user?.role ? [user.role] : []);
  const normalized = normalizeRoles(rawRoles);

  if (user?.isAdmin === true && !normalized.includes('ADMIN')) {
    normalized.push('ADMIN');
  }

  return normalized;
}

/**
 * Only platform staff run Suuq POS from here. Branch owners, managers and
 * suppliers manage their own workspaces on pos.suuq-s.com instead.
 */
export function isFullAdminUser(user) {
  const roles = getNormalizedRoles(user);
  return roles.includes('SUPER_ADMIN') || roles.includes('ADMIN');
}

export const DEFAULT_ADMIN_PATH = '/overview';

export function getDefaultAdminPath() {
  return DEFAULT_ADMIN_PATH;
}
